// extracted by mini-css-extract-plugin
export default {"scottSecretSantaApp":"Badge_scottSecretSantaApp__DeXr6","badgeContainer":"Badge_badgeContainer__lOxWb","image":"Badge_image__qSaCa"};